/**
 * BootstrapVue Compatibility Components
 * 
 * CREATED: Dec 2024 - Vue 3 Migration
 * WHO: GitHub Copilot (Claude Sonnet 4.5)
 * WHY: Provides Vue 3-compatible replacements for BootstrapVue components
 * 
 * PURPOSE:
 * - Central registration point for compatibility components
 * - Minimal migration path from BootstrapVue to Vue 3
 * - Easy to extend with additional components as needed
 * 
 * USAGE:
 * import { CompatComponents } from '@/components/compat'
 * app.use(CompatComponents)
 * 
 * MIGRATION PATH TO BOOTSTRAP-VUE-NEXT:
 * 1. When ready, uninstall bootstrap-vue
 * 2. Install bootstrap-vue-next
 * 3. Replace this import with: import { createBootstrap } from 'bootstrap-vue-next'
 * 4. Update registration: app.use(createBootstrap())
 * 5. Test and fix any breaking changes
 */

import BFormSelect from './BFormSelect.vue'
import BFormRadio from './BFormRadio.vue'
import BFormRadioGroup from './BFormRadioGroup.vue'
import BFormCheckbox from './BFormCheckbox.vue'
import BFormValidFeedback from './BFormValidFeedback.vue'
import BFormInvalidFeedback from './BFormInvalidFeedback.vue'

export const CompatComponents = {
	install(app) {
		// Register components globally to match BootstrapVue behavior
		// Supports both PascalCase and kebab-case naming conventions
		app.component('BFormSelect', BFormSelect)
		app.component('b-form-select', BFormSelect)
		app.component('BFormRadio', BFormRadio)
		app.component('b-form-radio', BFormRadio)
		app.component('BFormRadioGroup', BFormRadioGroup)
		app.component('b-form-radio-group', BFormRadioGroup)
		app.component('BFormCheckbox', BFormCheckbox)
		app.component('b-form-checkbox', BFormCheckbox)
		// Additional alias for explicit binding workaround (Vue 3 reactivity edge case)
		app.component('b-form-checkbox-compat', BFormCheckbox)
		app.component('BFormValidFeedback', BFormValidFeedback)
		app.component('b-form-valid-feedback', BFormValidFeedback)
		app.component('BFormInvalidFeedback', BFormInvalidFeedback)
		app.component('b-form-invalid-feedback', BFormInvalidFeedback)
	}
}

// Export individual components for direct import if needed
export { BFormSelect, BFormRadio, BFormRadioGroup, BFormCheckbox, BFormValidFeedback, BFormInvalidFeedback }
